import { ChangeDetectionStrategy, Component, ChangeDetectorRef, ViewChild } from '@angular/core';
import { WizHgroup } from '@wizeoo/akm-component-lib';
import { AgRendererComponent } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { ScenarioVO } from '../../../../../vo/scenarii/scenario.vo';

/**
 * renderer FD ou chrono (icone selon le Kind)
 */
@Component({
  selector: 'scen-spot-renderer',
  template: `<wiz-hgroup [style.padding-left]="data.level * 10 + 'px'" height="100%" width="100%" verticalAlign="center" >
  
  <span #blockBack
      [style.backgroundColor]="scenColor"
      width="10px"
      height="10px"
      class="scen-round-mark" 
      ></span>
      <wiz-label [wizLabel]="scenLabel"></wiz-label>
  </wiz-hgroup>`,
  styles: [':host {height:100%; width: 100%; max-width: 100%}'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ScenSpotRenderer implements AgRendererComponent {

  @ViewChild('gp', { read: WizHgroup, static: false }) gp: WizHgroup;

  private _data: ScenarioVO;
  public get data(): ScenarioVO {
    return this._data;
  }
  public set data(data: ScenarioVO) {
    // console.log('spotRenderer Data', data);
    this._data = data;
  }

  constructor(private cdref: ChangeDetectorRef) {}

  /** libellé du scénario en cours */
  public get scenLabel(): string {
    return this.data.trsLabel;
  }


  /** couleur du scénario en cours */
  public get scenColor(): string {
    let result: string = '';
    let scenCode: string = this.data?.code;
    if(!!scenCode) {
      let scen: ScenarioVO = this.data.model.scenarioEngine.getScenario(this.data.model.visionCode, scenCode);
      if(!!scen) {
        result = scen.color;
      }
    }

    return result;
  }


  refresh(params: ICellRendererParams): boolean {
    this.data = params.data;
    this.cdref.markForCheck();
    return true;
  }

  agInit(params: ICellRendererParams) {
    this.data = params.data;
    this.cdref.markForCheck();
  }
}
